/**
 * Espejo tipado del contrato de la API (backend, spec 43).
 *
 * Se declara aqui una sola vez para que ninguna feature invente su propia
 * forma de respuesta ni lea `error.message` cuando deberia ramificar por
 * `code`, que es el campo estable.
 */

export interface ApiSuccess<T> {
  readonly data: T;
  readonly meta?: Readonly<Record<string, unknown>>;
  readonly requestId: string;
}

export interface ApiErrorDetail {
  readonly field?: string;
  readonly message: string;
  readonly code?: string;
}

export interface ApiErrorBody {
  readonly statusCode: number;
  readonly code: string;
  readonly message: string;
  readonly details: readonly ApiErrorDetail[];
  readonly requestId: string;
  readonly timestamp: string;
  readonly path: string;
}

export interface PaginationMeta {
  readonly page: number;
  readonly pageSize: number;
  readonly total: number;
  readonly totalPages: number;
  readonly hasNext: boolean;
  readonly hasPrevious: boolean;
}

/**
 * Codigos de error que la interfaz trata de forma especifica.
 *
 * La lista es deliberadamente corta: solo entran los codigos que provocan un
 * comportamiento distinto en la UI. El resto se muestra con el mensaje del
 * servidor, que ya viene redactado para el usuario.
 */
export const API_ERROR_CODES = {
  unauthenticated: 'UNAUTHENTICATED',
  forbidden: 'FORBIDDEN_ACTION',
  validation: 'VALIDATION_ERROR',
  notFound: 'ENTITY_NOT_FOUND',
  routeNotFound: 'ROUTE_NOT_FOUND',
  rateLimited: 'RATE_LIMIT_EXCEEDED',
  concurrentModification: 'CONCURRENT_MODIFICATION',
  insufficientStock: 'INSUFFICIENT_STOCK',
  invalidTransition: 'INVALID_STATE_TRANSITION',
} as const;

export type ApiErrorCode = (typeof API_ERROR_CODES)[keyof typeof API_ERROR_CODES];
